export const EMPLOYMENT_YEARS = {
  'less than 6 months': 'Less than 6 months',
  '6 months - 1 year': '6 months - 1 year',
  '1-2 years': '1-2 Years',
  '2-3 years': '2-3 Years',
  '3+ years': '3+ Years',
};

export const EMPLOYMENT_STATUS = {
  Employed: 'Employed',
  'self-employed': 'Self Employed',
  Unemployed: 'Unemployed',
  Student: 'Student',
  Retired: 'Retired',
  Military: 'Military',
};

export const ricWorkflowName = 'dtm-luwa-dponly-ric';
